import content from './content'
import sections from './sections'

// 整个 site app 的 reducer，自己实现逻辑而不使用 combineReducers
function appReducer(state = initialState, action) {
  state = content(state, action) // 更新内容的actions，这个需要用到顶层的 state，所以先调用
  state = Object.assign({}, state, { sections: sections(state.sections, action) }) // 这个是版块相关的特定逻辑，所以只需要传递 state.section 到 actions 就好，逻辑更加清晰
  return state
}

export default appReducer


// WEBPACK FOOTER //
// ./app/javascript/app/site/reducers/app.js